import styled from 'styled-components';

export const GroupStar = styled.div``;

export const Star = styled.img``;
